import type { EffectiveFeatureCatalogueDto, FeatureKey } from '@erp/shared';
import { createContext, useContext } from 'react';

export interface FeatureAvailabilityContextValue {
  readonly catalogue: EffectiveFeatureCatalogueDto;
  readonly isEnabled: (key: FeatureKey) => boolean;
  readonly isPathEnabled: (pathname: string) => boolean;
  readonly keysForPath: (pathname: string) => readonly FeatureKey[];
}

export const FeatureAvailabilityContext = createContext<FeatureAvailabilityContextValue | null>(
  null,
);

export function useFeatureAvailability(): FeatureAvailabilityContextValue {
  const value = useContext(FeatureAvailabilityContext);
  if (value === null) throw new Error('FeatureAvailabilityProvider is missing.');
  return value;
}
